import React from "react";
import PropTypes from "prop-types";
import { Button, Form, Header, Modal } from "semantic-ui-react";

import useRelationshipFormIsValid from "../../hooks/useRelationshipFormIsValid";
import { DateInput } from "../../../../../CustomFormElements";
import { ConcatName } from "../../../../../../services/Entities";
import { forceValue } from "../../../../../../services/FormElements";

function SignerModal(props) {
  const { form, onClose, onSave, updateForm } = props;
  const requiredFields = ["signer_entity_data", "relationship_uuid"];

  const { isValid } = useRelationshipFormIsValid({ form, requiredFields });

  return (
    <Modal open key={form.relationship_uuid}>
      <Modal.Header>Edit Authorized Signer</Modal.Header>
      <Modal.Content>
        <Header as="h4">{`${forceValue(
          ConcatName(form.signer_entity_data || {})
        )} | ${forceValue(
          form.signer_entity_data ? form.signer_entity_data.tin : ""
        )}`}</Header>
        <br />
        <Form>
          <Form.Group>
            <DateInput
              data-testid="signer_start_date"
              asForm
              label="Start Date"
              name="start_date"
              onChange={updateForm}
              value={forceValue(form.start_date)}
            />
            <DateInput
              data-testid="signer_end_date"
              asForm
              label="End Date"
              name="end_date"
              disabled={!form.start_date}
              onChange={updateForm}
              min={form.start_date}
              value={forceValue(form.end_date)}
            />
          </Form.Group>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          id="cancelButton"
          color="grey"
          onClick={() => onClose({})}
          data-testid="signer_modal_cancel"
        >
          Cancel
        </Button>
        <Button
          id="submitButton"
          color="green"
          disabled={!isValid}
          onClick={onSave}
          data-testid="signer_modal_save"
        >
          Submit
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

SignerModal.propTypes = {
  form: PropTypes.shape().isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  updateForm: PropTypes.func.isRequired
};

export default SignerModal;
